import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import {
    GetListZoneMap,
    GetZoneDevicesLists,
    ZoneDetailFatherAndChild
} from "../../../../reduxToolkit/EmployeeZones/EmployeeZonesApi";
import {useParams} from "react-router-dom";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */


export const ShowDevicesApp =() =>{
    // translation
    const { t } = useTranslation();
    const {id} = useParams()
    const dispatch = useDispatch();
    const [ProfileImage, setProfileImage] = useState('');
    const [viewPlane, setViewPlane] = React.useState('');
    const [openNavigation, setOpenNavigation] = React.useState(true);
    const [selectedZone, setSelectedZone] = React.useState('');
    const [isDeviceList, setIsDeviceList] = React.useState(false);
    const [x, setX] = useState(0);
    const [y, setY] = useState(0);
    const [showPlaneModal, setShowPlaneModal] = useState(false);
    const [deletePlaneModal, setDeletePlaneModal] = useState(false);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    //use Selector hook to get state for redux store
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const {
        zoneDetailFatherAndChild,
        getListZoneMap,
        createZonePlane,
        setZoneImageCoordinate,
        getZoneDevicesLists,
    } = useSelector((state) => state.EmployeeZonesSlice);
      const {
            uploadImage
        } = useSelector((state) => state.sharedSlice);
       const {deleteDocumentById} = useSelector((state) => state.documentPanelSlice);

    const handleChange = (event) => {
        let value = event.target.value;
        setViewPlane(value);
        const checked = getListZoneMap?.filter((item) => item.id === value);
        setSelectedZone(checked[0]);
    };

    // get list of zone map
    useEffect(() => {
        if(id){
            const data = {
                zoneId: id,
            };
            dispatch(GetListZoneMap(data));
        }
    }, [createZonePlane, deleteDocumentById, uploadImage, viewPlane]);

    // get the selected zone map
    useEffect(() => {
        const checked = getListZoneMap?.filter((item) => item.id === viewPlane);
        setSelectedZone(checked[0]);
    }, [selectedZone, viewPlane, getListZoneMap, deleteDocumentById]);

    //get all device zone
    useEffect(() => {
        if(selectedZone?.id){
            const data = {
                zonePlaneId: selectedZone?.id,
            };
            dispatch(GetZoneDevicesLists(data));
        }
    }, [selectedZone?.id, setZoneImageCoordinate]);
    // get detail zone father and child
    useEffect(() => {
        dispatch(ZoneDetailFatherAndChild({zoneId: id}));
    }, [setZoneImageCoordinate, viewPlane, selectedZone]);

    // set map by default plane or map if no zone plane
    useEffect(() => {
        if (getListZoneMap?.length > 0) {
            setViewPlane(getListZoneMap[0].id);
        }
        if (getListZoneMap?.length === 0) {
            setViewPlane('map');
        }
    }, [deleteDocumentById]);



    return {
        openNavigation,
        setOpenNavigation,
        zoneDetailFatherAndChild,
        viewPlane,
        setDeletePlaneModal,
        getListZoneMap,
        setShowPlaneModal,
        setIsDeviceList,
        isDeviceList,
        getZoneDevicesLists,
        selectedZone,
        showPlaneModal,
        setProfileImage,
        deletePlaneModal,
        handleChange,
        t,
        dispatch,
        DEV,
        permission,
        x,y,
        id
    }
}
